import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2a528a69"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "apply-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "apply-title"
}, "报名信息", -1));

const _hoisted_3 = {
  class: "apply-form"
};
import { getUrlParams } from '@/plugins/utils';
import { ElMessage } from 'element-plus';
export default {
  emits: ['applySuccess'],

  setup(__props, {
    emit
  }) {
    const $http = inject('$http');
    const lectureId = getUrlParams('id');
    const formRefs = ref([]);

    const setFormRef = el => {
      formRefs.value.push(el);
    }; // 获取报名表单


    const applyForm = ref([]);

    const getApplyForm = async () => {
      const data = await $http.getTrainForm({
        business_type: 2,
        business_id: lectureId
      });
      applyForm.value = data;
    };

    getApplyForm(); // 报名

    const validCount = ref(0);

    const handleApply = async () => {
      validCount.value = 0;
      formRefs.value.forEach(item => {
        item.validate(valid => {
          if (valid) {
            validCount.value++;
          }
        });
      });

      if (validCount.value === formRefs.value.length) {
        const res = await $http.trainSignUp({
          live_id: lectureId,
          form_info: JSON.stringify(applyForm.value)
        });

        if (res == -1) {
          ElMessage.error('活动已结束');
        } else if (res == -2) {
          ElMessage.error('活动人数已满');
        } else {
          ElMessage.success('报名成功');
          emit('applySuccess');
        }
      }
    };

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("section", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyForm.value, item => {
        return _openBlock(), _createBlock(_component_el_form, {
          "label-position": "top",
          inline: "",
          model: item,
          ref_for: true,
          ref: setFormRef,
          key: item.id
        }, {
          default: _withCtx(() => [item.bindSource == 'phone_number' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: item.name,
            prop: "value",
            rules: [{
              required: item.required == 1 ? true : false,
              message: `请输入${item.name}`,
              trigger: 'blur'
            }, {
              pattern: /^[1][0-9]{10}$/,
              message: `请输入正确${item.name}`,
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              placeholder: `请输入${item.name}`,
              maxlength: 11,
              class: "apply-input"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
            _: 2
          }, 1032, ["label", "rules"])) : (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: item.name,
            prop: "value",
            rules: [{
              required: item.required == 1 ? true : false,
              message: `请输入${item.name}`,
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value,
              "onUpdate:modelValue": $event => item.value = $event,
              placeholder: `请输入${item.name}`,
              class: "apply-input"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]),
            _: 2
          }, 1032, ["label", "rules"]))]),
          _: 2
        }, 1032, ["model"]);
      }), 128))]), _createElementVNode("div", {
        class: "apply-btn-box"
      }, [_createElementVNode("button", {
        class: "apply-btn",
        onClick: handleApply
      }, "立即报名")])]);
    };
  }

};